import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import LanguagesForm from "../../components/languageslist/languageslist";
import Modal from "../../components/modal/modal";

// 🔹 Баннеры
import extralongbanner1 from "../../assets/banners/bannerextralong1.png";
import extralongbanner2 from "../../assets/banners/bannerextralong2.png";
import extralongbanner3 from "../../assets/banners/bannerextralong3.png";
import topbannerarm from "../../assets/banners/topbannerarm.png";
import topbannerru from "../../assets/banners/topbannerru.png";
import topbanneren from "../../assets/banners/topbanneren.png";
import topbanner2am from "../../assets/banners/topbanner2arm.png";
import topbanner2ru from "../../assets/banners/topbanner2ru.png";
import topbanner2en from "../../assets/banners/topbanner2en.png";
// Убираем импорт topicon - больше не нужен

// 🔹 Стили для ленточки
const ribbonStyles = `
  .ribbon-3d {
    position: absolute;
    top: -5px;
    left: -5px;
    z-index: 10;
    width: 100px;
    height: 70px;
    overflow: hidden;
    pointer-events: none;
  }
  .ribbon-3d-inner {
    position: absolute;
    display: block;
    width: 150px;
    height:30px;
    display:flex;
    align-items:center;
    justify-content:center;
    background-color: #006674;
    box-shadow: 0 3px 6px rgba(0,0,0,0.3);
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
     left: -50px;
    top: 9px;
    transform: rotate(-45deg);
    letter-spacing: 1px;
    border: 1px solid rgba(255,255,255,0.2);
  }
  
  
`;

// 🔹 Основная страница
const BecomeaCandidate = () => {
  const { t, i18n } = useTranslation();
const [searchParams] = useSearchParams();

const urlUserId = searchParams.get("userId");
const localUserId = localStorage.getItem("userId");

const userId = urlUserId || localUserId;
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [visibility, setVisibility] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const [modal, setModal] = useState({
    show: false,
    title: "",
    text: "",
    success: true,
  });
  const [profileStatus, setProfileStatus] = useState({
    isComplete: false,
    missingFields: [],
    candidateInDatabase: false,
  });

  // 🔹 Поля профиля
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [birthDay, setBirthDay] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [birthYear, setBirthYear] = useState("");

  const [jobTitle, setJobTitle] = useState("");
  const [jobPeriod, setJobPeriod] = useState("");
  const [jobTitles, setJobTitles] = useState("");
  const [education, setEducation] = useState("");
  const [extraEducation, setExtraEducation] = useState("");
  const [awards, setAwards] = useState("");
  const [volunteer, setVolunteer] = useState("");
  const [languages, setLanguages] = useState("");
  const [skills, setSkills] = useState("");
  const [computerKnowledge, setComputerKnowledge] = useState("");
  const [extraInfo, setExtraInfo] = useState("");

  const [serviceType, setServiceType] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [mainSphere, setMainSphere] = useState("");
  const [additionalSphere, setAdditionalSphere] = useState("");
  const [socialMedia, setSocialMedia] = useState({
    instagram: "",
    facebook: "",
    linkedin: "",
    youtube: "",
  });
  const [email, setEmail] = useState("");

  // 🔹 ПРОВЕРКА ТОЛЬКО НУЖНЫХ ПОЛЕЙ
  const checkProfileCompleteness = (userData) => {
    const requiredFields = [
      { key: "name", value: userData.name, label: "Имя" },
      { key: "lastName", value: userData.lastName, label: "Фамилия" },
      { key: "gender", value: userData.gender, label: "Пол" },
      { key: "birthday", value: userData.birthday, label: "Дата рождения" },
      { key: "serviceType", value: userData.serviceType, label: "Тип услуги" },
      {
        key: "sphere",
        value: userData.mainSphere || userData.additionalSphere,
        label: "Сфера деятельности (хотя бы одна)",
      },
      { key: "languages", value: userData.languages, label: "Языки" },
      { key: "skills", value: userData.skills, label: "Навыки" },
      { key: "email", value: userData.email, label: "Email" },
    ];

    const missingFields = requiredFields.filter((field) => {
      if (field.key === "sphere") {
        return !userData.mainSphere && !userData.additionalSphere;
      }
      return !field.value || field.value === "" || field.value === null;
    });

    return {
      isComplete: missingFields.length === 0,
      missingFields: missingFields.map((field) => field.label),
    };
  };

  // 🔹 Проверка кандидата в базе данных
  const checkCandidateInDatabase = async (userId) => {
    try {
      const response = await fetch(
        `/api/get_user.php?userId=${userId}`,
      );
      const data = await response.json();
      return data.exists || false;
    } catch (error) {
      console.error("Ошибка при проверке кандидата:", error);
      return false;
    }
  };

  // 🔹 Загрузка пользователя и проверка данных
  useEffect(() => {
    const fetchUserAndCheckData = async () => {
  try {
    const [searchParams] = window.location.search
      ? [new URLSearchParams(window.location.search)]
      : [new URLSearchParams()];

    const urlUserId = searchParams.get("userId");
    const localUserId = localStorage.getItem("userId");

    const userId = urlUserId || localUserId;

    console.log("🔍 USER ID:", userId);

    if (!userId) {
      setUser(null);
      setIsLoading(false);
      return;
    }

    const response = await fetch(`/api/get_user.php?id=${userId}`);
    const data = await response.json();

    console.log("📦 API:", data);

    if (data.success) {
      setUser(data.user);
    } else {
      setUser(null);
    }

  } catch (err) {
    console.error(err);
    setUser(null);
  } finally {
    setIsLoading(false);
  }
};

    fetchUserAndCheckData();
  }, []);

  if (isLoading) return <p className="text-center mt-10">Загрузка...</p>;
  if (!user) return <p className="text-center mt-10">Пользователь не найден</p>;

  // 🔹 Баннеры по языку
  let Topbanner1000A = topbannerarm;
  let Topbanner2000B = topbanner2am;
  let Topbanner = extralongbanner1;
  if (i18n.language === "ru") {
    Topbanner1000A = topbannerru;
    Topbanner2000B = topbanner2ru;
    Topbanner = extralongbanner2;
  } else if (i18n.language === "en") {
    Topbanner1000A = topbanneren;
    Topbanner2000B = topbanner2en;
    Topbanner = extralongbanner3;
  }

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="min-h-screen opacity-0 animate-[showtitle_1s_forwards]">
      {/* Добавляем стили ленточки */}
      <style>{ribbonStyles}</style>
      
      {modal.show && (
        <Modal
          text={modal.text}
          success={modal.success}
          onClose={() => setModal({ ...modal, show: false })}
        />
      )}

      <div className="w-[1000px] max-lg:w-full m-auto shadow-2xl p-3 shadow-black flex flex-col items-start">
        <img src={Topbanner} className="w-full" alt="" />

        <div className="w-full p-3 max-sm:p-1">
          <button
            onClick={() => toggleDropdown(0)}
            className="w-full relative pl-12 text-3xl max-md:text-lg p-3 bg-[#006674] text-white mt-3 rounded-lg shadow-2xl flex justify-start items-center gap-3"
          >
            <div className="ribbon-3d">
              <div className="ribbon-3d-inner">ԹՈՓ</div>
            </div>
            {t("toptitle")}
            <span className="ml-auto -translate-x-3 text-xl">
              {openIndex === 0 ? "▲" : "▼"}
            </span>
          </button>

          <div
            className={`overflow-hidden transition-all duration-200 ${
              openIndex === 0
                ? "max-h-[1000px] opacity-100 mt-2"
                : "max-h-0 opacity-0"
            }`}
          >
            <ul className="list-disc p-6 text-white text-lg rounded-lg">
              {t("toplist", { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="w-full p-3 max-sm:p-1">
          <button
            onClick={() => toggleDropdown(1)}
            className="w-full relative pl-12 text-3xl max-md:text-lg p-3 bg-[#006674] text-white mt-3 rounded-lg shadow-2xl flex justify-start items-center gap-3 "
          >
            {/* Ленточка вместо иконки */}
            <div className="ribbon-3d">
              <div className="ribbon-3d-inner">ԹՈՓ</div>
            </div>
            {t("wheretop")}
            <span className="ml-auto -translate-x-3 text-xl">
              {openIndex === 1 ? "▲" : "▼"}
            </span>
          </button>

          <div
            className={`overflow-hidden transition-all duration-200 ${
              openIndex === 1
                ? "max-h-[1000px] opacity-100 mt-2"
                : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-white text-lg">{t("wheredesc")}</p>
          </div>
        </div>

        <div className="flex w-full justify-between mt-6 gap-3 items-center">
          <Link className="w-[450px] max-sm:w-[300px] h-auto flex justify-center items-center font-semibold rounded-2xl bg-[#006674] text-white text-2xl relative overflow-hidden group">
            <div className="absolute opacity-0 transition-all duration-200 group-hover:opacity-20 inset-0 bg-[#006674]"></div>
            <img src={Topbanner1000A} className="w-full" alt="" />
          </Link>

          <Link className="w-[450px] max-sm:w-[300px] h-auto flex justify-center items-center font-semibold rounded-2xl bg-[#006674] text-white text-2xl relative overflow-hidden group">
            <div className="absolute opacity-0 transition-all duration-200 group-hover:opacity-20 inset-0 bg-[#006674]"></div>
            <img src={Topbanner2000B} className="w-full" alt="" />
          </Link>
        </div>

        {/* 🔹 ССЫЛКА НА ЗАПОЛНЕНИЕ ПРОФИЛЯ */}
        <div className="w-full mt-6">
          {!profileStatus.isComplete && (
            <p className="p-3 text-center flex flex-col items-center justify-center text-white">
              <span className="mb-1 sm:mb-0">{t("warntop") || ""}</span>
              <Link
                to="/update_user_data"
                className="underline underline-offset-2 ml-2 text-white font-semibold"
              >
                {t("warnlink") || ""}
              </Link>
            </p>
          )}

          {profileStatus.isComplete && !profileStatus.candidateInDatabase && (
            <p className="p-3 text-center flex flex-col items-center justify-center">
              <span className="mb-1 flex items-center gap-3 text-white sm:mb-0">
                {t("warnok")}
              </span>
              <Link
                to="/myPersonalPage"
                className="underline underline-offset-2 ml-2 text-white font-semibold"
              >
                {t("sendtolink")}
              </Link>
            </p>
          )}

          {profileStatus.candidateInDatabase && (
            <p className="p-3 text-center flex flex-col items-center justify-center text-white bg-blue-600">
              <span className="mb-1 sm:mb-0">📋 Ваша заявка уже подана</span>
              <span className="text-sm">
                Мы рассмотрим вашу кандидатуру в ближайшее время
              </span>
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default BecomeaCandidate;